import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { VendorRegistrationsComponent } from 'src/app/components/vendor-registrations/vendor-registrations.component'
import { MenuItem, MessageService } from 'primeng/api';
import { DatePipe, Location } from '@angular/common';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { first } from 'rxjs';
import { AttachmentsZipService } from 'src/app/services/attachments-zip.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-vendor-personal-details',
  templateUrl: './vendor-personal-details.component.html',
  styleUrls: ['./vendor-personal-details.component.scss'],
  providers: [VendorRegistrationsComponent, DatePipe]
})
export class VendorPersonalDetailsComponent implements OnInit {
  vendorDetails: any;
  vendorFormData: any;
  VendorTableData: any;
  vendorAttachmentData: any;
  // basicDetailsForm: FormGroup;
  public tableHeaderName = 'Completed Apps';
  miCompletedReport: MenuItem[];
  imageError: string = 'Document Not Found.';
  // @Input() mobilenumberEmitInput: any;

  public emailId: any;
  public deptRemarks: any;
  public statusList: any = [];
  public selectedStatus: any;
  public userId: any;
  public contractorId: any;
  public showDocEditDialog: boolean = false;
  public uploadOptions: any = [];
  public doc: any[];
  vendorForm: FormGroup;
  documentList: any = [];
  public ipAddress: any;

  constructor(
    private route: ActivatedRoute,
    private cryptoJsService: CryptoJsService,
    private jeService: JEService,
    private veReg: VendorRegistrationsComponent,
    private location: Location,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private zipService: AttachmentsZipService,
    private datePipe: DatePipe,
    private _personalDetalSer: FarmersDetailsService,
    private formBuilder: FormBuilder,
    private ipService: IpAddressService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.vendorForm = this.formBuilder.group({
      documentType: [null, Validators.required],
    });

    setTimeout(() => {
      this.statusList = [
        {
          name: 'Approve',
          id: 1
        },
        {
          name: 'Reject',
          id: 0
        }
      ]
    }, 200)

    // this.route.queryParams.subscribe(params => {
    //   //const encryptedMobile = params['Mobile'];
    //   const encryptedMobile = params['email'];
    //   if (encryptedMobile) {
    //     this.emailId = this.cryptoJsService.DecryptData(encryptedMobile);
    //     this.getVendorFullDetailsByEmail(this.emailId);
    //   }else{
    //   }
    // });
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    this.contractorId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.getVendorFullDetailsByEmail();
  }

  getVendorFullDetailsByEmail() {
    this.loader.start();
    this.jeService.getVendorFullDetailsByEmail(this.userId).subscribe({
      next: (data) => {
        this.loader.close();
        this.vendorDetails = data;
        this.vendorFormData = data.personalDetails.$values[0];
        // this.VendorTableData = data.componentDetails.$values;
        this.vendorAttachmentData = data.attachmentDetails.$values;
        // Handle your form display logic here;
      },
      error: (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    });
  }
  removeAttachment(index: number) {
    if (confirm('Are you sure you want to remove this attachment?')) {
      this.vendorAttachmentData.splice(index, 1);
    }
  }

  downloadZip() {
    let urls = this.vendorAttachmentData.map(item => item.Attachments);
    this.zipService.downloadZip(urls, `${this.vendorFormData?.Vendor_Name} (${this.datePipe.transform(new Date(), 'dd-MM-yyyy')})`);
  }

  onClickDocEdit() {
    this.showDocEditDialog = true;
    this.getUploadOptions(this.vendorFormData?.Vendor_Id);
  }

  onCloseDocDialog() {
    this.showDocEditDialog = false;
    this.documentList = [];
    this.vendorForm.reset();
  }

  getUploadOptions(id) {
    this.loader.start();
    this._personalDetalSer
      .getVendorRegDocTypeMaster(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.uploadOptions = data;

          } else {
            this.uploadOptions = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Upload otpions not loaded. ${data}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.uploadOptions = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  onUpload(event, docType, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // const encData = JSON.parse(this.cryptoJsService.DecryptDataPayload(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    const phNo = this.vendorFormData?.Mobile;

    this.loader.start();
    let document = this.vendorForm.controls['documentType'].value;
    this._personalDetalSer.uploadNewRegFile(data, phNo, document?.DocType).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          const docDetail = this.vendorAttachmentData.filter(item => item.Doc_Type === document?.DocType);
          if( docDetail.length > 0) {
            let reqBody = {
              "Id": docDetail[0]?.Id,
              "Type": "VendorReg"
            }
          
            let reqBodyAfterEncypt = {
              "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
            }
  
            this.loader.start();
            this._personalDetalSer.vendorRegFileDelete(reqBodyAfterEncypt).subscribe(
              (res2: any) => {
                this.loader.close();
  
                if(res2 == "File deleted"){
                  this.documentList.push({
                    documentType: document?.DocType,
                    attachmentsDoc: resp.data,
                  });
                  this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'File Updated Successfully',
                  });
                } else {
                  this.messageService.add({
                    severity: 'info',
                    summary: 'Info',
                    detail: `File Update Failed. ${res2}`,
                  });
                }
              },
              (error: any) => {
                this.loader.close();
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: `File Update Failed. ${error}`,
                });
              }
            )
          }
          else {
            this.documentList.push({
              documentType: document?.DocType,
              attachmentsDoc: resp.data,
            });
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'File Added Successfully',
            });
          }
          
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }

  isImage(path: string): boolean {
    return path
      ? /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/.test(path.toLowerCase())
      : false;
  }

  removeCaptureImg(i) {
    this.documentList.splice(i, 1);
  }
  
  onSubmitUpdateDoc(){
    let reqBody = {
      Email_ID: this.vendorFormData?.Email_ID,
      InsertAttachments: this.documentList,
      Network_Id: this.ipAddress,
      Terminal_ID: this.ipAddress,
    }

    this.updateVendorRegAttachments(reqBody);
  }

  updateVendorRegAttachments(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer.insertVendorRegAttachments(reqBodyAfterEncypt).subscribe({
      next: (data) => {
        this.loader.close();
        if (data.startsWith("Success")) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data,
          });
          this.onCloseDocDialog();
          this.getVendorFullDetailsByEmail();
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Info Message',
            detail: `Document not updated. ${data}`,
          });
        }
      },
      error: (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    });
  }



  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }
}